import React from 'react';
import cn from 'classnames';

import AdvertisementUtil from '@utils/AdvertisementUtil';
import Props from './Advertisement.props';
import { ADVERTISEMENT_DEVICE } from '@constants/enums';
import { useIsMobile } from '@hooks/useIsMobile';

import styles from './Advertisement.module.scss';

export const Advertisement = ({
  advertisementType,
  advertisementDevice = ADVERTISEMENT_DEVICE.DESKTOP_AND_MOBILE,
  className,
}: Props) => {
  const isMobile = useIsMobile();
  const advertisement = AdvertisementUtil.selectAdvertisement(advertisementType);
  const advertisementElement = (
    <div
      className={cn(styles.Advertisement, className)}
      dangerouslySetInnerHTML={{ __html: advertisement }}
    />
  );

  if (advertisementDevice === ADVERTISEMENT_DEVICE.DESKTOP_AND_MOBILE) {
    return advertisementElement;
  }

  if (advertisementDevice === ADVERTISEMENT_DEVICE.MOBILE && isMobile) {
    return advertisementElement;
  }

  if (advertisementDevice === ADVERTISEMENT_DEVICE.DESKTOP && !isMobile) {
    return advertisementElement;
  }

  return null;
};
